import React from "react";
import { FormInputFieldCurrency } from "@components-shared/mobile/inputs";
import { GamingLimitDataType } from "@data-types/membership/registration";
import { useTranslation } from "react-i18next";

export default function RegistrationMonthlyLimit(props: {
	gamingLimitsData: GamingLimitDataType | null;
	labelClassName?: string;
}) {
	const { gamingLimitsData, labelClassName } = props;

	const { t } = useTranslation("registration");

	return (
		<FormInputFieldCurrency
			label="registration:LIMIT_LABEL"
			labelClassName={labelClassName}
			name="limitAmount"
			className="form__field u-mar--bottom--reset"
			inputClassName="input input--sml"
			placeholder="MEMBERSHIP.ACCOUNT_ACTIVATION.MONTHLY_DEPOSIT_LIMIT_PLACEHOLDER"
			pattern={{
				value: /^\d+(\.\d{1,2})?$/,
				message: t("CASINO.BALANCE_TRANSFER.AMOUNT_VALIDATION_ERROR"),
			}}
			validate={{
				isEqual: (value: number) =>
					(value >= gamingLimitsData!.minLimit &&
						value <= gamingLimitsData!.maxLimit) ||
					t("LIMIT_RANGE_ERROR", {
						0: gamingLimitsData!.minLimit,
						1: gamingLimitsData!.maxLimit,
					}),
			}}
			required
		/>
	);
}
